import React, { useState, useEffect, useContext } from "react";
import "./sidebarCSS/sidebar.css";
import { Avatar, Button, Tooltip } from "@mui/material";
import {
  AddCircleOutline,
  SearchRounded,
  Clear,
} from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LogoutIcon from "@mui/icons-material/Logout";
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import Divider from "@mui/material/Divider";
import axios from "axios";
import Sidebarchat from "./Sidebarchat";
import PlatformSelector from "./PlatformSelector";
import adminPFP from "./sidebarIMG/adminPFP.jpg";
import { GlobalVariablesContext } from "../GlobalVariables";
import Inbox from "../modals/Inbox";
import Reply from "../modals/Reply";
import Compose_Email from "../modals/Compose_Email";
import toast from "react-hot-toast";
import { CiMail } from "react-icons/ci";

import InstagramIcon from '@mui/icons-material/Instagram'; // Added
import PhoneIcon from '@mui/icons-material/Phone'; // Call history icon
import { debounce } from "lodash";
import NotificationCenter from "./NotificationCenter";
import Email_Select_Modal from "../modals/Email_Select_Modal";
import CallManager from "../modals/CallManager";






function Sidebar() {
  const [search, setSearch] = useState([]);
  const [input, setInput] = useState("");
  const [sidebarBool, setSidebarBool] = useState(true);
  const [rooms, setLocalRooms] = useState([]);
  const [tmp, setTmp] = useState(0);
  const { setisLoggedIn2, logout, setRooms: setGlobalRooms, isMobileSidebarHidden, selectedPlatform, setSelectedPlatform, setCurrentUser, setIsMobileSidebarHidden } = useContext(GlobalVariablesContext)
  const [loader, setLoader] = useState(false);
  const [isDarkMode, setIsDarkMode] = useState(false);

  // New states for optimized Meta API
  const [metaChats, setMetaChats] = useState([]);
  const [waChats, setWaChats] = useState([]);
  const [metaPage, setMetaPage] = useState(1);
  const [hasMoreMeta, setHasMoreMeta] = useState(true);
  const [isFetchingMeta, setIsFetchingMeta] = useState(false);
  const [newChatModal, setNewChatModal] = useState(false);
  const [newChatForm, setNewChatForm] = useState({ name: '', phone: '', wbNum: '918278244128', sending: false, error: '' });

  useEffect(() => {
    if (isDarkMode) {
      document.body.classList.add('dark-mode');
    } else {
      document.body.classList.remove('dark-mode');
    }
  }, [isDarkMode]);

  const toggleTheme = () => {
    setIsDarkMode(!isDarkMode);
  };


  // ---------------------------------------------
  // ---------------------------------------------
  // Mail State (Removed for now as per premium update)

  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [open4, setOpen4] = useState(false); // Compose
  const [reply_mail, setReplyMail] = useState({});
  const [openSelectEmail, setOpenSelectEmail] = useState(false);
  const [selectedInboxEmail, setSelectedInboxEmail] = useState("");
  const [selectedFromEmail, setSelectedFromEmail] = useState("");
  const [callManagerOpen, setCallManagerOpen] = useState(false);

  const handleSelectEmail = (email) => {
    setSelectedInboxEmail(email);
    setOpenSelectEmail(false);
    setOpen2(true);
  };

  const handleComposeEmail = (email) => {
    // In sidebar, we might default to empty recipient or just open compose
    setSelectedFromEmail(email);
    setOpenSelectEmail(false);
    setOpen4(true);
    // You might want to pass 'from' email to compose if needed
  };

  const handleClose = () => {
    setOpen2(false);
    setOpen3(false);
    setOpen4(false);
  }

  const handleOpenReply = (data) => {
    setReplyMail(data);
    setOpen3(true);
    setOpen2(false);
  }

  const handleBackInbox = () => {
    setOpen3(false);
    setOpen2(true);
  }

  const handleCompose = () => {
    setOpen4(true);
    setOpen2(false);
  }

  const handleBackInboxFromCompose = () => {
    setOpen4(false);
    setOpen2(true);
  }

  const handleBackToSelect = () => {
    setOpen2(false);
    setOpenSelectEmail(true);
  }


  useEffect(() => {
    getRooms();
  }, [tmp]);

  useEffect(() => {
    // Optimization: Debounce the search input effects
    const delayedSearch = setTimeout(() => {
      if (rooms.length > 0) {
        setSearch(matcher(input, rooms));
      }
      if (input === "") {
        setSidebarBool(true);
      }
    }, 300); // 300ms delay

    return () => clearTimeout(delayedSearch);
  }, [input, rooms]);

  const getRooms = async (reset = false) => {
    try {
      console.log('[SIDEBAR] Fetching rooms from APIs...');
      setLoader(true);

      // Fetch WhatsApp Chats (always fetch all for now as WA doesn't have pagination yet in this context)
      // Only fetch if we haven't or if it's a polling update
      const waPromise = axios.get('https://casualfootwears.com/api/react_rooms2/');

      // Determine Meta API params
      let metaUrl = 'https://jutiyapa.com/api/conversations/';
      let metaParams = {};

      // If resetting (e.g. changing filter), start from page 1
      const currentPage = reset ? 1 : metaPage;
      if (reset) {
        setMetaPage(1);
        setMetaChats([]);
      }

      metaParams.page = currentPage;

      if (selectedPlatform !== 'all') {
        metaParams.platform = selectedPlatform === 'instagram' ? 'instagram' : 'facebook';
      }

      // Fetch Meta Chats
      const metaPromise = axios.get(metaUrl, { params: metaParams }).catch(err => {
        console.error('[SIDEBAR] Meta API error:', err);
        return { data: { results: [] } }; // Fallback to empty structure
      });
      
      const handoversPromise = axios.get('https://casualfootwears.com/api/human_handovers/').catch(err => {
        console.error('[SIDEBAR] Handovers API error:', err);
        return { data: [] };
      });

      const [waRes, metaRes, handoversRes] = await Promise.all([waPromise, metaPromise, handoversPromise]);
      const activeHandovers = new Map();
      (handoversRes.data || []).forEach(h => activeHandovers.set(String(h.session_id), h));

      // --- Process WhatsApp Data ---
      let newWaChats = [];
      if (waRes.data?.recent_messages) {
        newWaChats = waRes.data.recent_messages.map((room) => ({
          // Use phone_number as id — it is the unique key for a WhatsApp conversation.
          // The API does not return a distinct `id` field; room.id is always undefined.
          id: String(room.phone_number),
          name: room.profile_name,
          text: room.text,
          phone: room.phone_number,
          message_count: room.message_count,
          admin_unseen_count: room.admin_unseen_count,
          timestamp: room.timestamp,
          msg_status_code: room.msg_status_code,
          whatsapp_bussiness_number: room.whatsapp_bussiness_number,
          platform: 'whatsapp',
          human_needs_action: activeHandovers.has(String(room.phone_number)),
          handover_data: activeHandovers.get(String(room.phone_number)),
          original_data: room
        }));
        setWaChats(newWaChats);
      }

      // --- Process Meta Data ---
      let newMetaChats = [];
      const metaResults = metaRes.data.results || metaRes.data || []; // Handle pagination results or fallback

      // Update pagination state
      if (metaRes.data.next) {
        setHasMoreMeta(true);
      } else {
        setHasMoreMeta(false);
      }

      if (Array.isArray(metaResults)) {
        newMetaChats = metaResults.map(chat => {
          const platform = chat.platform === 'page' ? 'facebook' : (chat.platform || 'instagram');
          let otherParticipant = null;


          if (platform === 'instagram' || platform === 'facebook') {
            // Meta Platforms: New structure "participants": { "sender": {...}, "recipient": {...} }
            // Logic: Prefer sender, then recipient.
            if (chat.participants && !Array.isArray(chat.participants)) {
              otherParticipant = chat.participants.sender || chat.participants.recipient;
            } else if (Array.isArray(chat.participants)) {
              otherParticipant = chat.participants.find(p => p.username !== null) || chat.participants[0];
            }
          } else {
            // Others
            if (Array.isArray(chat.participants)) {
              otherParticipant = chat.participants.find(p => p.username !== null) || chat.participants[0];
            }
          }

          // Identify Customer (Phone/User ID)
          let phone = "";
          if (otherParticipant) {
            phone = String(otherParticipant.user_id);
          }

          // [NEW] Robust Business ID Extraction
          // Conversation ID is usually "UserID_BusinessID" or vice-versa.
          // We identify the Business ID by excluding the Customer ID (phone).
          let businessUserId = null;
          const convId = chat.conversation_id || chat.id;
          if (convId && phone) {
            const parts = convId.split('_');
            if (parts.length === 2) {
              // If one part is the customer phone, the other is likely the business ID
              if (parts[0] === phone) businessUserId = parts[1];
              else if (parts[1] === phone) businessUserId = parts[0];
            }
          }
          // Fallback
          if (!businessUserId && chat.participants?.recipient?.user_id) {
            businessUserId = chat.participants.recipient.user_id;
          }

          const name = otherParticipant?.username || otherParticipant?.full_name || "Unknown User";

          // Profile Picture Logic
          let profilePic = null;
          if ((platform === "instagram" || platform === "facebook") && otherParticipant?.profile_picture_url) {
            const ppUrl = otherParticipant.profile_picture_url;
            if (ppUrl.startsWith("/media/")) {
              profilePic = "http://jutiyapa.com" + ppUrl;
            } else {
              profilePic = ppUrl;
            }
          }

          return {
            id: chat.conversation_id, // Use string ID
            name: name,
            text: chat.last_message?.message_text || (chat.last_message?.media_url ? "Sent a media" : ""),
            phone: phone, // Ensure string
            business_user_id: businessUserId, // [NEW] Dynamic Sender ID
            profile_picture: profilePic, // Added
            message_count: 0,
            admin_unseen_count: chat.unread_count !== undefined ? chat.unread_count : (chat.last_message?.is_read ? 0 : 1),
            timestamp: new Date(chat.updated_at).getTime() / 1000,
            msg_status_code: chat.last_message?.is_read ? 'read' : 'delivered',
            whatsapp_bussiness_number: null, // Not applicable
            platform: platform,
            human_needs_action: activeHandovers.has(String(phone)),
            handover_data: activeHandovers.get(String(phone)),
            original_data: chat
          };
        });

        // If not resetting, prevent duplicates when appending
        setMetaChats(prev => {
          if (reset) return newMetaChats;
          // Filter out any that already exist in prev (though pagination shouldn't overlap usually, but safety)
          const existingIds = new Set(prev.map(c => c.id));
          const uniqueNew = newMetaChats.filter(c => !existingIds.has(c.id));
          return [...prev, ...uniqueNew];
        });
      }

    } catch (error) {
      console.error('[SIDEBAR] Error fetching data:', error);
    } finally {
      setLoader(false);
    }
  };

  // Combine chats for display
  useEffect(() => {
    let combined = [];
    if (selectedPlatform === 'all') {
      combined = [...waChats, ...metaChats];
    } else if (selectedPlatform === 'whatsapp') {
      combined = [...waChats];
    } else {
      combined = [...metaChats]; // metaChats already filtered by API if backend supports it OR if we filter client side.
      // Note: Current getRooms implementation fetches filtered Meta if selectedPlatform is insta/fb.
      // If selectedPlatform is Wa, metaChats might be stale or empty, which is fine.
    }

    // Sort combined list
    combined.sort((a, b) => b.timestamp - a.timestamp);
    setLocalRooms(combined);
    // Sync to global context so Chat.jsx can use it for swipe navigation
    setGlobalRooms(combined);
  }, [waChats, metaChats, selectedPlatform]);

  // Initial Fetch & Platform Change
  useEffect(() => {
    // When platform changes, we reset and fetch
    // If we switch to 'whatsapp', we don't strictly *need* to re-fetch WA if we have it, but consistent behavior is good.
    // If switching to Insta/FB, we MUST re-fetch to apply backend filter.
    getRooms(true);
  }, [selectedPlatform]);


  // Polling Logic for Delta Updates
  useEffect(() => {
    const intervalId = setInterval(async () => {
      // Only poll for updates, don't full reset

      let waPromise = null;
      if (selectedPlatform === 'all' || selectedPlatform === 'whatsapp') {
        waPromise = axios.get('https://casualfootwears.com/api/react_rooms2/');
      }

      // For Meta: Use updated_after if we have chats
      let metaParams = {};
      if (metaChats.length > 0) {
        const maxTime = Math.max(...metaChats.map(c => c.timestamp));
        metaParams.updated_after = maxTime;
      }

      const handoversPromise = axios.get('https://casualfootwears.com/api/human_handovers/').catch(err => ({ data: [] }));

      if (selectedPlatform !== 'whatsapp') {
        // Poll Meta
        if (selectedPlatform !== 'all') {
          metaParams.platform = selectedPlatform === 'instagram' ? 'instagram' : 'facebook';
        }
        axios.get('https://jutiyapa.com/api/conversations/', { params: metaParams })
          .then(async res => {
            const results = res.data.results || [];
            if (results.length > 0) {
              const handoversRes = await handoversPromise;
              const activeHandovers = new Map();
              (handoversRes.data || []).forEach(h => activeHandovers.set(String(h.session_id), h));
              
              // Merge updates
              const updatedChats = results.map(chat => {
                const platform = chat.platform === 'page' ? 'facebook' : (chat.platform || 'instagram');
                let otherParticipant = null;

                if (platform === 'instagram' || platform === 'facebook') {
                  // Meta Platforms: New structure "participants": { "sender": {...}, "recipient": {...} }
                  if (chat.participants && !Array.isArray(chat.participants)) {
                    otherParticipant = chat.participants.sender || chat.participants.recipient;
                  } else if (Array.isArray(chat.participants)) {
                    otherParticipant = chat.participants.find(p => p.username !== null) || chat.participants[0];
                  }
                } else {
                  // Others
                  if (Array.isArray(chat.participants)) {
                    otherParticipant = chat.participants.find(p => p.username !== null) || chat.participants[0];
                  }
                }

                // Identify Customer (Phone/User ID)
                let phone = "";
                if (otherParticipant) {
                  phone = String(otherParticipant.user_id);
                }

                let businessUserId = null;
                const convId = chat.conversation_id || chat.id;
                if (convId && phone) {
                  const parts = convId.split('_');
                  if (parts.length === 2) {
                    if (parts[0] === phone) businessUserId = parts[1];
                    else if (parts[1] === phone) businessUserId = parts[0];
                  }
                }

                const name = otherParticipant?.username || otherParticipant?.full_name || "Unknown User";

                let profilePic = null;
                if ((platform === "instagram" || platform === "facebook") && otherParticipant?.profile_picture_url) {
                  const ppUrl = otherParticipant.profile_picture_url;
                  if (ppUrl.startsWith("/media/")) {
                    profilePic = "http://jutiyapa.com" + ppUrl;
                  } else {
                    profilePic = ppUrl;
                  }
                }

                return {
                  id: chat.conversation_id,
                  name: name,
                  text: chat.last_message?.message_text || (chat.last_message?.media_url ? "Sent a media" : ""),
                  phone: phone,
                  business_user_id: businessUserId, // [NEW] Corrected Extraction
                  profile_picture: profilePic, // Added
                  message_count: 0,
                  admin_unseen_count: chat.unread_count !== undefined ? chat.unread_count : (chat.last_message?.is_read ? 0 : 1),
                  timestamp: new Date(chat.updated_at).getTime() / 1000,
                  msg_status_code: chat.last_message?.is_read ? 'read' : 'delivered',
                  whatsapp_bussiness_number: null,
                  platform: platform,
                  human_needs_action: activeHandovers.has(String(phone)),
                  handover_data: activeHandovers.get(String(phone)),
                  original_data: chat
                };
              });

              setMetaChats(prev => {
                const prevMap = new Map(prev.map(c => [c.id, c]));
                updatedChats.forEach(c => prevMap.set(c.id, c));

                // Re-sort after merge to ensure top
                const merged = Array.from(prevMap.values());
                merged.sort((a, b) => b.timestamp - a.timestamp);
                return merged;
              });
            }
          }).catch(console.error);
      }

      // Update Handovers on unchanged Meta chats and poll WA
      handoversPromise.then(handoversRes => {
        const activeHandovers = new Map();
        (handoversRes.data || []).forEach(h => activeHandovers.set(String(h.session_id), h));

        // Always sync meta chats handover status even if no new messages
        setMetaChats(prev => prev.map(c => {
            const h = activeHandovers.get(String(c.phone));
            const has_h = activeHandovers.has(String(c.phone));
            if (c.human_needs_action !== has_h) {
                return { ...c, human_needs_action: has_h, handover_data: h || null };
            }
            return c;
        }));

        if (waPromise) {
          waPromise.then(res => {
            if (res.data?.recent_messages) {
              const newWa = res.data.recent_messages.map((room) => ({
                // Use phone_number as id — unique key for a WhatsApp conversation.
                id: String(room.phone_number),
                name: room.profile_name,
                text: room.text,
                phone: room.phone_number,
                message_count: room.message_count,
                admin_unseen_count: room.admin_unseen_count,
                timestamp: room.timestamp,
                msg_status_code: room.msg_status_code,
                whatsapp_bussiness_number: room.whatsapp_bussiness_number,
                platform: 'whatsapp',
                human_needs_action: activeHandovers.has(String(room.phone_number)),
                handover_data: activeHandovers.get(String(room.phone_number)),
                original_data: room
              }));
              setWaChats(newWa);
            }
          }).catch(console.error);
        }
      });

    }, 10000);

    return () => clearInterval(intervalId);
  }, [selectedPlatform, metaChats]);

  // Load More Handler (Infinite Scroll)
  const fetchMoreMeta = async () => {
    if (!hasMoreMeta || isFetchingMeta) return;
    setIsFetchingMeta(true);
    const nextPage = metaPage + 1;
    setMetaPage(nextPage);

    let metaParams = { page: nextPage };
    if (selectedPlatform !== 'all') {
      metaParams.platform = selectedPlatform === 'instagram' ? 'instagram' : 'facebook';
    }

    try {
      const res = await axios.get('https://jutiyapa.com/api/conversations/', { params: metaParams });
      const results = res.data.results || [];

      if (res.data.next) {
        setHasMoreMeta(true);
      } else {
        setHasMoreMeta(false);
      }

      const moreChats = results.map(chat => {
        // ... mapper logic ...
        const platform = chat.platform === 'page' ? 'facebook' : (chat.platform || 'instagram');
        let otherParticipant = null;

        if (platform === 'instagram' || platform === 'facebook') {
          // Meta Platforms: New structure "participants": { "sender": {...}, "recipient": {...} }
          if (chat.participants && !Array.isArray(chat.participants)) {
            otherParticipant = chat.participants.sender || chat.participants.recipient;
          } else if (Array.isArray(chat.participants)) {
            otherParticipant = chat.participants.find(p => p.username !== null) || chat.participants[0];
          }
        } else {
          // Others
          if (Array.isArray(chat.participants)) {
            otherParticipant = chat.participants.find(p => p.username !== null) || chat.participants[0];
          }
        }

        // Identify Customer (Phone/User ID)
        let phone = "";
        if (otherParticipant) {
          phone = String(otherParticipant.user_id);
        }

        // [NEW] Robust Business ID Extraction
        let businessUserId = null;
        const convId = chat.conversation_id || chat.id;
        if (convId && phone) {
          const parts = convId.split('_');
          if (parts.length === 2) {
            if (parts[0] === phone) businessUserId = parts[1];
            else if (parts[1] === phone) businessUserId = parts[0];
          }
        }
        // Fallback
        if (!businessUserId && chat.participants?.recipient?.user_id) {
          businessUserId = chat.participants.recipient.user_id;
        }

        const name = otherParticipant?.username || otherParticipant?.full_name || "Unknown User";

        let profilePic = null;
        if ((platform === "instagram" || platform === "facebook") && otherParticipant?.profile_picture_url) {
          const ppUrl = otherParticipant.profile_picture_url;
          if (ppUrl.startsWith("/media/")) {
            profilePic = "http://jutiyapa.com" + ppUrl;
          } else {
            profilePic = ppUrl;
          }
        }

        return {
          id: chat.conversation_id,
          name: name,
          text: chat.last_message?.message_text || (chat.last_message?.media_url ? "Sent a media" : ""),
          phone: phone, // Ensure string
          business_user_id: businessUserId, // [NEW] Corrected Extraction
          profile_picture: profilePic, // Added
          message_count: 0,
          admin_unseen_count: chat.unread_count !== undefined ? chat.unread_count : (chat.last_message?.is_read ? 0 : 1),
          timestamp: new Date(chat.updated_at).getTime() / 1000,
          msg_status_code: chat.last_message?.is_read ? 'read' : 'delivered',
          whatsapp_bussiness_number: null,
          platform: platform,
          original_data: chat
        };
      });

      setMetaChats(prev => [...prev, ...moreChats]);

    } catch (err) {
      console.error("Error loading more chats", err);
    } finally {
      setIsFetchingMeta(false);
    }
  };

  // Scroll Handler
  const handleScroll = (e) => {
    const { scrollTop, clientHeight, scrollHeight } = e.target;
    if (scrollHeight - scrollTop <= clientHeight + 50) { // Near bottom
      if (hasMoreMeta && !isFetchingMeta && selectedPlatform !== 'whatsapp') {
        fetchMoreMeta();
      }
    }
  };


  const openNewChatModal = () => {
    setNewChatForm({ name: '', phone: '', wbNum: '918278244128', sending: false, error: '' });
    setNewChatModal(true);
  };

  const handleNewChatSubmit = () => {
    const { name, phone, wbNum } = newChatForm;
    // Validate
    if (!name.trim())
      return setNewChatForm(f => ({ ...f, error: 'Please enter a customer name.' }));
    if (!phone.trim() || !/^\d{10,15}$/.test(phone.trim()))
      return setNewChatForm(f => ({ ...f, error: 'Enter a valid phone number (10-15 digits, no + or spaces).' }));

    // Close modal and immediately open the chat — no automatic message sent
    setNewChatModal(false);
    setCurrentUser({
      name: name.trim(),
      phone: phone.trim(),
      wb_num: wbNum,
      platform: 'whatsapp',
      text: '',
      conversation_id: null,
      profile_picture: null,
      business_user_id: null,
      handover_data: null,
      human_needs_action: false,
      original_data: null,
    });
    if (window.innerWidth < 700) setIsMobileSidebarHidden(true);
    toast.success(`Chat opened for ${name.trim()} — type a message or send a template.`);
  };


  const matcher = (s, values) => {
    const re = RegExp(`.*${s.toLowerCase().split("").join(".*")}.*`);
    return values.filter(
      (v) => (v.name?.toLowerCase().match(re) || v.phone?.toString().toLowerCase().match(re))
    );
  };

  const handleChange = (e) => {
    setSidebarBool(false);
    setInput(e.target.value);
  };



  // --------------------------------------

  // const handleOpen = (str, data) => { ... } // Removed
  // const handleClose = () => { ... } // Removed
  // const handleBackInbox = () => { ... } // Removed
  // const handleOpenReply = async (data) => { ... } // Removed



  return (
    <>
      <div className="Sidebar" style={isMobileSidebarHidden && window.innerWidth < 700 ? { display: 'none' } : undefined}>
        <div className="Sidebar__header">
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <Avatar src={adminPFP} className="premium-avatar" />

            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
              <Tooltip title="Mail">
                <div className="premium-icon-btn" onClick={() => setOpenSelectEmail(true)}>
                  <CiMail style={{ fontSize: "24px" }} strokeWidth={1} />
                </div>
              </Tooltip>

              <Tooltip title="Instagram Posts">
                <div className="premium-icon-btn" onClick={() => window.open("https://casualfootwears.com/posts", "_self")}>
                  <InstagramIcon sx={{ fontSize: "24px" }} />
                </div>
              </Tooltip>

              <Tooltip title="Call History">
                <div className="premium-icon-btn" onClick={() => setCallManagerOpen(true)}>
                  <PhoneIcon sx={{ fontSize: "24px" }} />
                </div>
              </Tooltip>
            </div>
          </div>

          <div className="Sidebar__headerRight" style={{ gap: '10px' }}>
            <Tooltip title="New WhatsApp Chat">
              <div className="premium-icon-btn" onClick={openNewChatModal}>
                <AddCircleOutline sx={{ fontSize: "24px" }} />
              </div>
            </Tooltip>

            <Tooltip title={isDarkMode ? "Light Mode" : "Dark Mode"}>
              <div className="premium-icon-btn" onClick={toggleTheme}>
                {isDarkMode ? <LightModeIcon sx={{ fontSize: "24px" }} /> : <DarkModeIcon sx={{ fontSize: "24px" }} />}
              </div>
            </Tooltip>

            <NotificationCenter isDarkMode={isDarkMode} customClass="premium-icon-btn" />

            <Tooltip title="Logout">
              <div className="premium-icon-btn" onClick={logout}>
                <LogoutIcon sx={{ fontSize: "24px" }} />
              </div>
            </Tooltip>
          </div>
        </div>
        <Divider />
        <div className="Sidebar__search">
          <div className="Sidebar__searchContainer">
            <SearchRounded />
            <input
              placeholder="Search or Start New Chat"
              type="text"
              value={input}
              onChange={handleChange}
            />
            {input && (
              <Clear className="clear-icon" onClick={() => setInput("")} />
            )}
          </div>
        </div>

        <PlatformSelector
          selectedPlatform={selectedPlatform}
          onPlatformChange={setSelectedPlatform}
        />

        <Divider />

        {rooms.length > 0 ? (
          sidebarBool ? (
            <div className="Sidebar__chats" onScroll={handleScroll}>
              {rooms
                .map((room, index) => (
                  <div key={index}>
                    <Sidebarchat
                      addNewChat={true}
                      name={room.name}
                      text={room.text}
                      phone={room.phone}
                      message_count={room.message_count}
                      admin_unseen_count={room.admin_unseen_count}
                      human_needs_action={room.human_needs_action}
                      handover_data={room.handover_data}
                      timestamp={room.timestamp}
                      msg_status_code={room.msg_status_code?.toLowerCase()}
                      whatsapp_bussiness_number={room.whatsapp_bussiness_number}
                      platform={room.platform}
                      roomData={room}
                      profile_picture={room.profile_picture}
                      business_user_id={room.business_user_id}
                    />
                  </div>
                ))}
            </div>
          ) : (
            <div className="Sidebar__chats">
              {search
                .filter(room => selectedPlatform === 'all' || room.platform === selectedPlatform)
                .map((room, index) => (
                  <div key={index}>
                    <Sidebarchat
                      addNewChat={true}
                      name={room.name}
                      text={room.text}
                      phone={room.phone}
                      message_count={room.message_count}
                      admin_unseen_count={room.admin_unseen_count}
                      human_needs_action={room.human_needs_action}
                      handover_data={room.handover_data}
                      timestamp={room.timestamp}
                      msg_status_code={room.msg_status_code?.toLowerCase()}
                      whatsapp_bussiness_number={room.whatsapp_bussiness_number}
                      platform={room.platform}
                      roomData={room}
                      profile_picture={room.profile_picture}
                      business_user_id={room.business_user_id}
                    />
                  </div>
                ))}
            </div>
          )
        ) : (
          <div className="loading">
            <div className="gear"></div>
            <h2>LOADING CHATS</h2>
          </div>
        )}
      </div>
      <div className="selectMSG">SELECT USER TO VIEW MESSAGES</div>

      {openSelectEmail && (
        <Email_Select_Modal
          open={openSelectEmail}
          handleClose={() => setOpenSelectEmail(false)}
          handleSelectEmail={handleSelectEmail}
          handleComposeEmail={handleComposeEmail}
          slected_num={""} // Not relevant for sidebar generally
        />
      )}

      {open2 && (
        <Inbox
          open2={open2}
          handleClose={handleClose}
          handleOpenReply={handleOpenReply}
          handleCompose={handleCompose}
          isDarkMode={isDarkMode}
          selectedEmail={selectedInboxEmail}
          handleBack={handleBackToSelect}
        />
      )}

      {open3 && (
        <Reply
          open3={open3}
          handleClose={handleClose}
          reply_mail={reply_mail}
          handleBackInbox={handleBackInbox}
          isDarkMode={isDarkMode}
        />
      )}

      {open4 && (
        <Compose_Email
          open4={open4}
          setOpen4={setOpen4}
          email={selectedFromEmail || "gopalayush04@gmail.com"}
          handleOpen={handleBackInboxFromCompose}
          isDarkMode={isDarkMode}
        />
      )}

      {/* Call Manager Modal */}
      <CallManager
        open={callManagerOpen}
        onClose={() => setCallManagerOpen(false)}
        isDarkMode={isDarkMode}
      />

      {/* ─── New WhatsApp Chat Modal ─── */}
      {newChatModal && (
        <div className="nc-overlay" onClick={() => setNewChatModal(false)}>
          <div className="nc-modal" onClick={e => e.stopPropagation()}>
            <div className="nc-header">
              <span className="nc-title">✨ New WhatsApp Chat</span>
              <button className="nc-close" onClick={() => setNewChatModal(false)}>✕</button>
            </div>

            <div className="nc-body">
              <label className="nc-label">Customer Name</label>
              <input
                className="nc-input"
                placeholder="e.g. Rahul Sharma"
                value={newChatForm.name}
                onChange={e => setNewChatForm(f => ({ ...f, name: e.target.value, error: '' }))}
                onKeyDown={e => e.key === 'Enter' && handleNewChatSubmit()}
              />

              <label className="nc-label">Phone Number <span className="nc-hint">(with country code, no +)</span></label>
              <input
                className="nc-input"
                placeholder="e.g. 919876543210"
                value={newChatForm.phone}
                onChange={e => setNewChatForm(f => ({ ...f, phone: e.target.value.replace(/\D/g, ''), error: '' }))}
                onKeyDown={e => e.key === 'Enter' && handleNewChatSubmit()}
              />

              <label className="nc-label">Send From (Business Number)</label>
              <select
                className="nc-select"
                value={newChatForm.wbNum}
                onChange={e => setNewChatForm(f => ({ ...f, wbNum: e.target.value }))}
              >
                <option value="919468063603">919468063603 — Led Shoe India (LD)</option>
                <option value="918278244128">918278244128 — LEDSHOES (LDS)</option>
                <option value="919485998901">919485998901 — Lightshoes (LTS)</option>
                <option value="919485998902">919485998902 — Lightshoe (LT)</option>
                <option value="919485998903">919485998903 — Amdesi (AMD)</option>
                <option value="919485998904">919485998904 — AmdesiIN (AMDI)</option>
                <option value="919485998905">919485998905 — OnlineLedShoes (OLS)</option>
                <option value="919485998906">919485998906 — OnlineLedShoe (OL)</option>
                <option value="919485998907">919485998907 — Lighting Shoe (LS)</option>
                <option value="919485998908">919485998908 — Theled Shoes (TLS)</option>
                <option value="919485998909">919485998909 — The Ledshoe (TL)</option>
                <option value="919485998910">919485998910 — Shiningshoes (SS)</option>
                <option value="919485904987">919485904987 — Litfeet Led Shoes (LTF)</option>
                <option value="919485904988">919485904988 — Ledfeetshoes (LDF)</option>
                <option value="919485972920">919485972920 — Lumi Ledshoes (LMI)</option>
                <option value="919485972921">919485972921 — Lumoshoes (LMO)</option>
                <option value="919499240313">919499240313 — Flashsteps shoes (FS)</option>
                <option value="919485987613">919485987613 — Myled shoes (MLS)</option>
                <option value="919466022393">919466022393 — Ledlight Shoes (LLS)</option>
              </select>

              {newChatForm.error && (
                <div className="nc-error">{newChatForm.error}</div>
              )}
            </div>

            <div className="nc-footer">
              <button className="nc-btn-cancel" onClick={() => setNewChatModal(false)}>Cancel</button>
              <button
                className="nc-btn-start"
                onClick={handleNewChatSubmit}
                disabled={newChatForm.sending}
              >
                {newChatForm.sending ? 'Starting…' : '🚀 Start Chat'}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default Sidebar;
